import { format } from 'date-fns'
import { getEffectiveStartDate } from 'Data/payment-plan.js'

export function getEffectiveFrom(insurance) {
  let result = getEffectiveStartDate(insurance)
  return result ? format(result, 'MMMM do, yyyy') : '-'
}
